import { Video, MapPin, PartyPopper, Shirt, Users, QrCode } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import Block3Columns from "../../components/Block3Columns";
import ImageContainer from "../../components/ImageContainer";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import MasonryGallery from "../../components/MasonryGallery";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/acad0dcb-588b-40fc-9ed2-b079362ad9ca" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_gallery,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Incorporaciones() {
  const DataDisplay = ({ data }) => (
    <div>
      <ImageContainer
        src={data.imagen_portada}
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      >
        {" "}
      </ImageContainer>

      <div className="lightbluebg padding">
        <Block2ColumnsText
          col1={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 flex flex-col items-center  gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600">
                <MapPin className="w-8 h-8 block translate-y-[1px]" />
              </div>

              <div
                className="w-[90%]"
                dangerouslySetInnerHTML={{
                  __html: data.bloque1,
                }}
              />
            </div>
          }
          col2={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 flex flex-col items-center  gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-red-50 text-red-600">
                <Video className="w-8 h-8 block" />
              </div>
              <div
                className="w-[90%]"
                dangerouslySetInnerHTML={{
                  __html: data.bloque2,
                }}
              />
         
            </div>
          }
        >
          {" "}
        </Block2ColumnsText>
      </div>

      <div className="bluebg padding">
        {" "}
        <div
          className="text-center mb-4"
          dangerouslySetInnerHTML={{
            __html: data.bloque3,
          }}
        />
        <Block3Columns
          col1={
            <>
              <div className="group border bg-[#135283]  border-gray-200 rounded-2xl p-6  transition-all duration-300 hover:-translate-y-2  hover:border-gray-400">
                {/* icono */}
                <div className="text-white group-hover:text-[#febe10] transition-colors duration-300">
                  <PartyPopper size={28} />
                </div>

                {/* contenido */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque4,
                  }}
                />
              </div>
            </>
          }
          col2={
            <>
              <div className="group border  bg-[#135283] border-gray-200 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-2 hover:border-gray-400">
                <div className="text-white group-hover:text-[#febe10] transition-colors duration-300">
                  <Shirt size={28} />
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque5,
                  }}
                />
              </div>
            </>
          }
          col3={
            <>
              <div className="group border  bg-[#135283] border-gray-200 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-2  hover:border-gray-400">
                <div className="text-white group-hover:text-[#febe10] transition-colors duration-300">
                  <Users size={28} />
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </div>
            </>
          }
        />
      </div>
      <div className="bg-[#004270] pb-10">
        <div className="pb-10">
          <div className="lightbluebg padding layout8">
            {" "}
            <div
              className="text-center "
              dangerouslySetInnerHTML={{
                __html: data.bloque7,
              }}
            />
            <Block2ColumnsText
              col1={
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque8,
                  }}
                />
              }
              col2={
                <div className="bg-red-50  p-4">
                  <div className="text-red-600">
                    <QrCode size={50} />
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque9,
                    }}
                  />
                </div>
              }
            ></Block2ColumnsText>
          </div>
        </div>
      </div>
      <div className="padding">
        <div
          className="layout6 text-center fontsize14 cta-link "
          dangerouslySetInnerHTML={{
            __html: data.bloque10,
          }}
        />

        <MasonryGallery gallery={data.galeria}></MasonryGallery>
      </div>

      <div className="blackbg padding ">

        {" "}
        <div
        className="layout8 text-center cta-link "
          dangerouslySetInnerHTML={{
            __html: data.bloque11,
          }}
        />
      </div>
    </div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default Incorporaciones;
